/**
 * GeChiUI dependencies
 */
import { Path, SVG } from '@gechiui/primitives';

const reset = (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
		<Path d="M7 11.5h10V13H7z" />
	</SVG>
);

export default reset;
